import React, { useEffect, useRef, useState } from "react";
import FetchImage from "../fetchImage";
import Select from "react-select";
import LoadingBar from "react-top-loading-bar";
import { customerFeedback } from "../../../actions/memberAction";
import { getMember } from "../../../actions/miscAction";
import { Modal } from "react-bootstrap";

const ISSUE_TYPE = [
  { name: "Technology Issue", value: "Technology Issue" },
  { name: "Technology Suggestion or Request", value: "Technology Suggestion or Request" },
  { name: "Customer Service", value: "Customer Service" },
];

const customStyles = {
  indicatorSeparator: (styles) => ({ display: "none" }),
  option: (provided, state) => ({
    ...provided,
    "&:hover": {
      backgroundColor: "#47ad1d",
      color: "#fff",
    },
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    color: state.isSelected ? "#fff" : "black",
    backgroundColor: state.isSelected ? "#47ad1d" : provided.backgroundColor,
    maxHeight: "84px",
  }),
  control: (base, state) => ({
    ...base,
    height: 42,
    minHeight: 42,
    borderColor: state.isFocused ? "#47AD1D" : "#e4e4e4",
    boxShadow: state.isFocused ? "0 0 0 0.5px #47AD1D" : "0",
    border: state.isHovered ? "0" : "1px solid #e4e4e4",

    "&:hover": {
      borderColor: state.isFocused ? "#47AD1D" : "0",
      boxShadow: state.isFocused ? "0 0 0 0.5px #47AD1D" : "0",
    },
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    "&:hover": {
      backgroundColor: "rgb(95, 50, 187, 10%)",
      color: "#6119c0",
    },
  }),
};

const Help = ({ show, onHide }) => {
  const ref = useRef(null);
  const member = getMember();
  const [step, setStep] = useState(1);
  const [data, setData] = useState({ type: "", feedback: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const value = { type: "", feedback: "" };
    setStep(1);
    setData(value);
  }, [show]);

  const submitHandler = () => {
    setLoading(true);
    ref?.current?.continuousStart();
    const payload = {
      type: data?.type,
      description: data?.feedback,
    };
    customerFeedback(payload, (res) => {
      if (res?.status === 200) {
        setLoading(false);
        setStep(2);
        ref?.current?.complete();
      } else {
        setLoading(false);
        ref?.current?.complete();
      }
    });
  };

  return (
    <>
      <LoadingBar color="#47ad1d" ref={ref} />
      <Modal
        show={show}
        onHide={onHide}
        className="modal fade salvex-modal modal-md hide-header"
        dialogClassName="modal-dialog modal-dialog-centered"
        contentClassName="ask-question-modal-height"
      >
        <Modal.Body>
          {step === 1 && (
            <>
              <h4 class="width-90">What type of support do you need?</h4>
              <div class="close-btn" data-bs-dismiss="modal" onClick={onHide}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p>Fill out the form to enter the details and our team will get in touch with you.</p>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="company" class="form-label">
                      Name
                    </label>
                    <input type="text" class="form-control" id="name" name="name" value={member?.name01} disabled />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="company" class="form-label">
                      Company
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="company"
                      name="company"
                      value={member?.company_name || "N/A"}
                      disabled
                    />{" "}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="company" class="form-label">
                      Phone
                    </label>
                    <input type="tel" class="form-control" id="phone" name="phone" value={member?.phone} disabled />{" "}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="email" class="form-label">
                      Email
                    </label>
                    <input type="email" class="form-control" id="email" name="email" value={member?.email} disabled />{" "}
                  </div>
                </div>
              </div>
              <div class="form-group ">
                <label for="message" class="form-label">
                  What type of support do you need?
                </label>
                <Select
                  value={ISSUE_TYPE?.filter((he) => he?.value === data?.type)}
                  className="basic-single"
                  classNamePrefix="select-search"
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  name="industry"
                  options={ISSUE_TYPE}
                  placeholder="Select Issue Type"
                  styles={customStyles}
                  onChange={(e) => {
                    const value = { ...data };
                    value["type"] = e.value;
                    setData(value);
                  }}
                />
              </div>
              <div class="form-group mb-0">
                <label for="message" class="form-label">
                  Please describe your issue in detail
                </label>
                <textarea
                  class="form-control"
                  id="message"
                  name="message"
                  onChange={(e) => {
                    const value = { ...data };
                    value.feedback = e.target.value;
                    setData(value);
                  }}
                  value={data?.feedback}
                  style={{ fontSize: "1rem" }}
                ></textarea>{" "}
              </div>
            </>
          )}
          {step === 2 && (
            <>
              <div class="sucessfull-askQuestion-box  sucessfull-submit-box help-box-success">
                <FetchImage image={"crosshair.svg"} alt="crosshair" />
                <h4 style={{ fontSize: "1.25rem", marginBottom: "10px" }}>Thank you!</h4>
                <p style={{ fontSize: "1rem" }}>Our team will get in touch as soon as possible.</p>
                <button
                  type="button"
                  class={`btn btn-default `}
                  onClick={() => {
                    setStep(1);
                    onHide();
                  }}
                >
                  Close
                </button>
              </div>
            </>
          )}
        </Modal.Body>
        {step === 1 && (
          <div class="modal-footer">
            <a
              href="javascript:void(0)"
              class={`btn btn-default btn-xl  ${
                (loading || data?.type?.length === 0 || data?.feedback?.length === 0) && "disabled"
              }`}
              onClick={submitHandler}
            >
              Send
            </a>
          </div>
        )}
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default Help;
